import type {KindedUnion} from '@gl/lit/types/union.js';

export enum PaidMediaExportFields {
  MATCH_FIELDS = 'mappedMatchFields',
  EXPORT_NAME = 'exportName',
  WHEN_TO_ADVANCE_USER = 'whenToAdvanceUser',
  DURATION = 'duration',
  TABLE_NAME = 'tableName',

  EXPORT_ACTION = 'exportFields.exportAction',
  SENDER_EMAIL = 'exportFields.senderEmail',
  TEMPLATE_ID = 'exportFields.templateID',

  EXISTING_SFMC_DATA_EXTENSION = 'exportFields.existing_list_id',
}

export interface AllowedSenderEmailsResponse {
  senders: SenderEmail[];
}

export interface CampaignTriggersErrorResponse {
  error: string;
}

export type AllowedSenderEmails = KindedUnion<{
  loading: void;
  success: {value: SenderEmail[]};
  error: {value: Error};
}>;

export type SenderEmail = {
  name: string;
  email: string;
};

export type EmailTemplate = {
  id: string;
  name: string;
  thumbnail_url?: string;
  variables?: string[];
};

export interface CampaignTemplatesResponse {
  templates: EmailTemplate[];
}
